<div  *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined && global.globalAgencyId!=0">
    <div class="row ">
      <div class="col pl-3">
        <h4 class="mb-0 font-header" style="font-weight: 700; color: #502189;"><label (click)="close271.emit()"><i
              class="fa fa-chevron-circle-left"   title="Close" style="font-size:24px"></i></label>&nbsp;271 Details</h4>
      </div>
    </div>
    <div>
      <div class="row mb-2">
        <div class="col ">
          <div widget class="card border-0 box-shadow mt-2">
            <div class="card-header transparent text-muted d-flex align-items-center justify-content-start gap-2">
              <button class="btn blue-btn btn-sm" [disabled]="dataviewList271.length == 0"
                (click)="GetEligibilityExportCsv()">Export</button>
              <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal"
                data-bs-target="#Generate270" [disabled]="clientlist.length==0" (click)="creategenerate270()">Generate 270</button>
              <button class="btn blue-btn btn-sm" (click)="Refreshview271()">Refresh</button>
            </div>
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
              <ejs-grid #gridview271 [dataSource]='datavieweb271 | async' [allowResizing]='true' allowPaging='true'
                [pageSettings]='initialPage' [allowFiltering]='true' [allowSorting]='true'
                (actionBegin)="onActionCompleteview271Clients($event)" [filterSettings]='filterSettings'
                (dataStateChange)='dataStateChange271Clients($event)' (rowDataBound)='rowDataBound($event)'
                [showColumnChooser]='true' [selectionSettings]='selectionOptions'
                (checkBoxChange)="CheckboxforViewEligibility($event)" (queryCellInfo)='validatebutton($event)'
                (resizeStop)="onResize($event)">
                <e-columns>
                  <e-column type='checkbox' uid="checkbox" maxWidth=50 width='50' textAlign='center' [allowEditing]='true'
                    editType="booleanedit" [edit]='checkparams' [showInColumnChooser]='false'>
                  </e-column>
                  <e-column minWidth=100 field="view271" uid="action" headerText="Action" [showInColumnChooser]='true'
                    [allowFiltering]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table text-center" (click)="viewlasteb(data.clientPkId)"><i
                          class="fa fa-eye"></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="clientName" headerText="Name" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="gender" headerText="Gender" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="dob" type='date' headerText="DOB" [format]='formatOptions'></e-column>
                  <e-column minWidth=100 field="clientID" headerText="Medicaid ID" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="city" headerText="City" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="state" headerText="State" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="zipCode" headerText="Zip Code" type="string" [allowFiltering]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="lastEligibilityCheck" type='date' headerText="Last Eligibility Check"
                    [format]='formatOptions'></e-column>
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div class="d-none d-lg-block">
                        <span id='show' (click)='showColumn()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                          </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
              <div *ngIf="dataviewList271?.length == 0" class="text-center" style="color:red">
                <p>No data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------------------------------Generate 270 modal ----------------------------------------------------->
  <span id="openModal4" data-bs-target="#Generate270" data-bs-toggle="modal"></span>
  <div class="modal fade" id="Generate270" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Generate 270</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="col-lg-12">
            <div class="row mt-2">
              <div class="col-lg-6">
                <label>Group<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              </div>
              <div class="col-lg-6">
                <ng-select [(ngModel)]="generate270.groupId" [searchable]="true" [clearable]="true" [items]="groupList"
                  bindLabel="lovValue" class="tdropdown" bindValue="id"
                  [disabled]="global.globalAgencyId==0||global.globalAgencyId==null" (ngModelChange)="getpayorList()">
                </ng-select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6">
                <label>Payor<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              </div>
              <div class="col-lg-6">
                <ng-select [(ngModel)]="generate270.payorId" [searchable]="true" [clearable]="true" [items]="payorList"
                  bindLabel="Value" (ngModelChange)="getCompanyList()" [disabled]="global.globalAgencyId==0||global.globalAgencyId==null || generate270.groupId=='00000000-0000-0000-0000-000000000000'||
                  generate270.groupId==null||generate270.groupId==undefined  " class="tdropdown" bindValue="Key">
                </ng-select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6">
                <label>Company<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              </div>
              <div class="col-lg-6">
                <ng-select [(ngModel)]="generate270.companyId" [searchable]="true" [clearable]="true"
                  [items]="companyList" bindLabel="Value" [disabled]="global.globalAgencyId==0
                ||generate270.payorId==null || generate270.payorId==undefined || generate270.payorId=='00000000-0000-0000-0000-000000000000'"
                  class="tdropdown" bindValue="Key">
                </ng-select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-6">
                <label>ClearingHouse<sup class="super-script">&nbsp;*&nbsp;</sup></label>
              </div>
              <div class="col-lg-6">
                <ng-select [(ngModel)]="generate270.clearingHouseId" [searchable]="true" [clearable]="true"
                  [items]="clearingHouseList" bindLabel="Value"
                  [disabled]="global.globalAgencyId==0||global.globalAgencyId==null" class="tdropdown" bindValue="Key">
                </ng-select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <button class="btn blue-btn btn-sm text-right ms-1" type="button" [disabled]="generate270.groupId=='00000000-0000-0000-0000-000000000000'||generate270.groupId==null
            ||generate270.payorId=='00000000-0000-0000-0000-000000000000'||generate270.payorId==null||generate270.clearingHouseId=='00000000-0000-0000-0000-000000000000'
            ||generate270.clearingHouseId==null||global.globalAgencyId==0||global.globalAgencyId==null||
            generate270.companyId =='00000000-0000-0000-0000-000000000000'|| generate270.companyId==null || generate270.companyId==undefined"
              (click)="generate270file()">Generate</button>
            <button class="btn blue-btn btn-sm text-right ms-1" type="button" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------------------------------create 270 ----------------------------------------------------->
  <span id="openModal5" data-bs-target="#Create270Detail1" data-bs-toggle="modal"></span>
  <div class="modal fade" id="Create270Detail1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Created 270 Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <table class="table  table-hover table-bordered mt-3">
            <thead style="min-width: 100px;position: relative;color:white;background-color:   #502189;">
              <th class="pointer" style="min-width: 100px;position: relative;color:white;background-color:   #502189;">S
                No.
              </th>
              <th class="pointer">Filepath
              </th>
              <th class="pointer" style="text-align: center;">Download
              </th>
              <th class="pointer" style="text-align: center;">View
              </th>
            </thead>
            <tbody>
              <tr>
                <td class="text-center p-0"
                  style="width: 65px; vertical-align: middle;background-color: whitesmoke;color: black;">
                  1
                </td>
                <td style="width: 57%; word-break:break-all; vertical-align: middle;">
                  {{created270?.fileName}}
                </td>
                <td class="text-center p-0" style="vertical-align: middle;">
                  <button class="btn blue-btn btn-sm mr-2" (click)=download270(created270.filePath)> <i
                      class="fa fa-download" aria-hidden="true"></i></button>
                </td>
                <td class="text-center p-0" style="vertical-align: middle;">
                  <button class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#view270C"
                    (click)="viewFiles=true">
                    <i class="fa fa-eye" aria-hidden="true"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <button class="btn blue-btn btn-sm text-right" type="button" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-------------------------------view270 270 ----------------------------------------------------->
  <span id="openModal6" data-bs-target="#view270C" data-bs-toggle="modal"></span>
  <div class="modal fade" id="view270C" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog1 modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header1 border-0">
          <h5 class="modal-title text-left font-header">270 Record</h5>
          <div class="ms-auto d-flex gap-2 align-items-center">
            <button class="btn blue-btn btn-sm" (click)="kendopdfdownloadList()">
              Download
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="viewFiles=false" aria-label="Close">
              <span aria-hidden="true"></span>
            </button>
          </div>
        </div>
        <div class="modal-body modal-body1">
          <div class="row">
            <div class="col-lg-12">
              <kendo-pdf-export #pdflist paperSize="A4">
                <div style="width:730px;padding-left: 15px;">
                  <div class="row">
                    <div class="col-lg-10 font-weight-bold">
                      <h5>270 Report</h5>
                    </div>
                    <div class="col-lg-2 font-weight-bold">
                      {{today|date:'MM/dd/yyyy'}}
                    </div>
                  </div>
                  <div *ngIf="viewFiles">
                    <div class="font-weight-bold">{{created270.payerDetail.payer_Name}}</div>
                    <div class="font-weight-bold">{{created270.payerDetail.payer_Address_1}}</div>
                    <div class="font-weight-bold">{{created270.payerDetail.payer_City}}
                      ,&nbsp;{{created270.payerDetail.payer_State}}
                      ,&nbsp;{{created270.payerDetail.payer_Zip}}</div>
                    <div class="font-weight-bold">PayerID:{{created270.payerDetail.billing_payor_ID}}</div>
                    <hr style="
                      margin-top: 1.5%;
                      border-top: 1px solid rgb(19, 17, 17);
                      width: 100%;
                      box-shadow: 0px 1px 1px #0c0c0c;
                      " />
                    <div class="row w-100">
                      <div class="col-lg-4">
                        <div class="font-weight-bold">{{created270.companyDetail.company_Name}}</div>
                        <div class="font-weight-bold">{{created270.companyDetail.company_Address_1}}</div>
                        <div class="font-weight-bold">
                          {{created270.companyDetail.company_City}},&nbsp;{{created270.companyDetail.company_State}}
                          ,&nbsp;{{created270.companyDetail.company_Zip}}</div>
                      </div>
                      <div class="col-lg-4"></div>
                      <div class="col-lg-4">
                        <div class="font-weight-bold">
                          Date:&nbsp;&nbsp;&nbsp;&nbsp;{{created270.created_Date|date:'MM/dd/yyyy'}}</div>
                      </div>
                    </div>
                    <hr style="
                        margin-top: 1.5%;
                        border-top: 1px solid rgb(19, 17, 17);
                        width: 100%;
                        box-shadow: 0px 1px 1px #0c0c0c;
                        " />
                    <span class="mt-1"></span>
                    <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />
                    <div class="row w-100">
                      <div class="col-lg-3">
                        Name
                      </div>
                      <div class="col-lg-2">
                        DOB
                      </div>
                      <div class="col-lg-2">
                        Gender
                      </div>
                      <div class="col-lg-2">
                        City
                      </div>
                      <div class="col-lg-1">
                        State
                      </div>
                      <div class="col-lg-2">
                        Insurence No
                      </div>
                    </div>
                    <hr style="
                          margin-top: 1.5%;
                          border-top: 1px solid rgb(19, 17, 17);
                          width: 100%;
                          box-shadow: 0px 1px 1px #0c0c0c;
                          " />
                    <ng-container *ngFor="let val1 of created270.clinetDetail">
                      <div class="row w-100">
                        <div class="col-lg-3">
                          {{val1.clinet_LastName}},&nbsp;{{val1.clinet_FirstName}} &nbsp;{{val1.cLient_MiddleName}}
                        </div>
                        <div class="col-lg-2">
                          {{val1.client_DOB|date:'MM/dd/yyyy'}}
                        </div>
                        <div class="col-lg-2">
                          <span *ngIf="val1.client_Gender=='F'">
                            FEMALE
                          </span>
                          <span *ngIf="val1.client_Gender=='M'">
                            MALE
                          </span>
                        </div>
                        <div class="col-lg-2">
                          {{val1.clinet_City}}
                        </div>
                        <div class="col-lg-1">
                          {{val1.clinet_State}}
                        </div>
                        <div class="col-lg-2">
                          {{val1.client_Insurance}}
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </kendo-pdf-export>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="viewFiles=false">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <!--------------------------------------View 271-------------------------------------------------->
  <span id="openModal7" data-bs-target="#view271C" data-bs-toggle="modal"></span>
  <div class="modal fade" id="view271C" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog1 modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header1 border-0">
          <h5 class="modal-title text-left font-header">271 Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="viewFiles271=false"></button>
        </div>
        <div class="modal-body modal-body1">
          <div class="row">
            <div class="col-lg-12">
              <div style="width:730px ;padding-left:15px">
                <div>271 Report</div>
                <div *ngIf="viewFiles271">
                  <ng-container *ngFor="let edi271 of edi271list">
                    <div class="row">
                      <div class="col-lg-3">FileName</div>
                      <div class="col-lg-9">: {{edi271.fileName}}</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">Imported Date</div>
                      <div class="col-lg-9">: {{edi271.importedDate|date:'MM/dd/yyyy'}}</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">Unique ISA Id</div>
                      <div class="col-lg-9">: {{edi271.unique271ISA}}</div>
                    </div>
                    <div class="row">
                      <div class="col-lg-3">Interchange Date</div>
                      <div class="col-lg-9">: {{edi271.interchangeDateTime|date:'MM/dd/yyyy'}}</div>
                    </div>
                    <div class="Sender">
                      <h2>Sender</h2>
                      <div *ngIf="edi271.sender_EntityIdentifier!=null && edi271.sender_EntityIdentifier!=''" class="row">
                        <div class="col-lg-3">Entity</div>
                        <div class="col-lg-9">: {{edi271.sender_EntityIdentifier}}</div>
                      </div>
                      <div *ngIf="edi271.sender_Name!=null && edi271.sender_Name!=''" class="row">
                        <div class="col-lg-3">Name</div>
                        <div class="col-lg-9">: {{edi271.sender_Name}}</div>
                      </div>
                      <div *ngIf="edi271.sender_Id!= null && edi271.sender_Id!=''" class="row">
                        <div class="col-lg-3">ID</div>
                        <div class="col-lg-9">: {{edi271.sender_Id}} <br> ({{edi271.sender_IdQualifier}})</div>
                      </div>
                      <h6
                        *ngIf="edi271.sender_CommunicationNumberQualifier1!=null && edi271.sender_CommunicationNumberQualifier1!=''">
                        Contact</h6>
                      <div>{{edi271.sender_ContactName}}</div>
                      <div class="row"
                        *ngIf="edi271.sender_CommunicationNumber1!=null && edi271.sender_CommunicationNumber1!=''">
                        <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier1}}</div>
                        <div class="col-lg-9">: {{edi271.sender_CommunicationNumber1}}</div>
                      </div>
                      <div *ngIf="edi271.sender_CommunicationNumber2!=null && edi271.sender_CommunicationNumber2!=''"
                        class="row">
                        <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier2}}</div>
                        <div class="col-lg-9">: {{edi271.sender_CommunicationNumber2}}</div>
                      </div>
                      <div *ngIf="edi271.sender_CommunicationNumber3!=null && edi271.sender_CommunicationNumber3!=''"
                        class="row">
                        <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier3}}</div>
                        <div class="col-lg-9">: {{edi271.sender_CommunicationNumber3}}</div>
                      </div>
                    </div>
  
                    <div class="Receiver">
                      <h2>Receiver</h2>
                      <div *ngIf="edi271.receiver_EntityIdentifier!=null && edi271.receiver_EntityIdentifier!=''"
                        class="row">
                        <div class="col-lg-3">Entity</div>
                        <div class="col-lg-9">: {{edi271.receiver_EntityIdentifier}}</div>
                      </div>
                      <div *ngIf="edi271.receiver_Name!=null && edi271.receiver_Name!=''" class="row">
                        <div class="col-lg-3">Name</div>
                        <div class="col-lg-9">: {{edi271.receiver_Name}}</div>
                      </div>
                      <div *ngIf="edi271.receiver_Id!=null && edi271.receiver_Id!=''" class="row">
                        <div class="col-lg-3">ID</div>
                        <div class="col-lg-9">: {{edi271.receiver_Id}} <br> ({{edi271.receiver_IdQualifier}})</div>
                      </div>
                      <div
                        *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                        class="row">
                        <div class="col-lg-3">Address</div>
                        <div class="col-lg-9">: {{edi271.receiver_AddressLine1}} <br
                            *ngIf="edi271.receiver_AddressLine2 != null">
                          {{edi271.receiver_AddressLine2}} <br> {{edi271.receiver_City}} <br>
                          {{edi271.receiver_StateCode}}
                          <br> {{edi271.receiver_ZipCode}}
                        </div>
                      </div>
                    </div>
                    <ng-container *ngFor="let client of edi271?.clients">
                      <div class="Client">
                        <h3>Subscriber</h3>
                        <div class="ClientBasicDetails">
                          <div *ngIf="client.clientName!=null && client.clientName!=''" class="row">
                            <div class="col-lg-3">Name</div>
                            <div class="col-lg-9">: {{client.clientName}}</div>
                          </div>
                          <div *ngIf="client.clientID!=null && client.clientID!=''" class="row">
                            <div class="col-lg-3">ID</div>
                            <div class="col-lg-9">: {{client.clientID}} <br> ({{client.clientIdQualifier}})</div>
                          </div>
                          <div
                            *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                            class="row">
                            <div class="col-lg-3">Address</div>
                            <div class="col-lg-9">: {{client.addressLine1}} <br *ngIf="client.addressLine2 != null">
                              {{client.addressLine2}} <br> {{client.city}} <br> {{client.state}} <br> {{client.zipCode}}
                            </div>
                          </div>
                          <div *ngIf="client.dOB!=null && client.dOB!=''" class="row">
                            <div class="col-lg-3">DOB</div>
                            <div class="col-lg-9">: {{client.dOB|date:'MM/dd/yyyy'}}</div>
                          </div>
                          <div *ngIf="client.gender!=null && client.gender!=''" class="row">
                            <div class="col-lg-3">Gender</div>
                            <div class="col-lg-9">: {{client.gender}}</div>
                          </div>
                        </div>
                        <div class="AAADetails" *ngIf="client.aaaDetails!=null ">
                          <h5>Subscriber Validation</h5>
                          <ng-container *ngFor="let aaa of client?.aaaDetails">
                            <div *ngIf="aaa.validRequest!=null && aaa.validRequest!=''" class="row">
                              <div class="col-lg-3">Valid ReQuest</div>
                              <div class="col-lg-9">: {{aaa.validRequest}}</div>
                            </div>
                            <div *ngIf="aaa.agencyQualifier!=null && aaa.agencyQualifier!=''" class="row">
                              <div class="col-lg-3">Agency Qualifier</div>
                              <div class="col-lg-9">: {{aaa.agencyQualifier}}</div>
                            </div>
                            <div *ngIf="aaa.rejectReason!=null && aaa.rejectReason!=''" class="row">
                              <div class="col-lg-3">Reason For Rejection</div>
                              <div class="col-lg-9">: {{aaa.rejectReason}}</div>
                            </div>
                            <div *ngIf="aaa.followupAction!=null && aaa.followupAction!=''" class="row">
                              <div class="col-lg-3">Follow-Up Action</div>
                              <div class="col-lg-9">: {{aaa.followupAction}}</div>
                            </div>
                          </ng-container>
                        </div>
                        <div class="LoopDetails">
                          <ng-container *ngFor="let loop of client?.loopDetails">
                            <div class="EBandMessage">
                              <h5>Eligibility and Benefit Info</h5>
                              <div
                                *ngIf="loop.eligibilityorBenefitInformation!=null && loop.eligibilityorBenefitInformation!=''"
                                class="row">
                                <div class="col-lg-3">Eligibility or Beneefit Information</div>
                                <div class="col-lg-9">: {{loop.eligibilityorBenefitInformation}}</div>
                              </div>
                              <div *ngIf="loop.benefitCoverageLevel!=null && loop.benefitCoverageLevel!=''" class="row">
                                <div class="col-lg-3">Coverage Level</div>
                                <div class="col-lg-9">: {{loop.benefitCoverageLevel}}</div>
                              </div>
                              <div *ngIf="loop.serviceType!=null && loop.serviceType!=''" class="row">
                                <div class="col-lg-3">Service Covered</div>
                                <div class="col-lg-9">: {{loop.serviceType}}</div>
                              </div>
                              <div *ngIf="loop.insuranceType!=null && loop.insuranceType!=''" class="row">
                                <div class="col-lg-3">Insurance Type</div>
                                <div class="col-lg-9">: {{loop.insuranceType}}</div>
                              </div>
                              <div *ngIf="loop.planCoverageDescription!=null && loop.planCoverageDescription!=''"
                                class="row">
                                <div class="col-lg-3">Plan Coverage Description</div>
                                <div class="col-lg-9">: {{loop.planCoverageDescription}}</div>
                              </div>
                              <div *ngIf="loop.timePeriodQualifier!=null && loop.timePeriodQualifier!=''" class="row">
                                <div class="col-lg-3">Time Period</div>
                                <div class="col-lg-9">: {{loop.timePeriodQualifier}}</div>
                              </div>
                              <div *ngIf="loop.benefitAmount!=null && loop.benefitAmount!=0" class="row">
                                <div class="col-lg-3">Benefit Amount</div>
                                <div class="col-lg-9">: {{loop.benefitAmount}}</div>
                              </div>
                              <div *ngIf="loop.benefitPercent!=null && loop.benefitPercent!=0" class="row">
                                <div class="col-lg-3">Benefit Percentage</div>
                                <div class="col-lg-9">: {{loop.benefitPercent}}</div>
                              </div>
                              <div *ngIf="loop.quantityQualifier!=null && loop.quantityQualifier!=''" class="row">
                                <div class="col-lg-3">Quantity Qualifier</div>
                                <div class="col-lg-9">: {{loop.quantityQualifier}}</div>
                              </div>
                              <div *ngIf="loop.authorizationorCertificationIndicator!=null && loop.benefitQuantity!=''"
                                class="row">
                                <div class="col-lg-3">Benefit Quantity</div>
                                <div class="col-lg-9">: {{loop.benefitQuantity}}</div>
                              </div>
                              <div
                                *ngIf="loop.authorizationorCertificationIndicator!=null && loop.authorizationorCertificationIndicator!=''"
                                class="row">
                                <div class="col-lg-3">Authorization Certification</div>
                                <div class="col-lg-9">: {{loop.authorizationorCertificationIndicator}}</div>
                              </div>
                              <div *ngIf="loop.inPlanNetwork!=null && loop.inPlanNetwork!=''" class="row">
                                <div class="col-lg-3">InPlan Network</div>
                                <div class="col-lg-9">: {{loop.inPlanNetwork}}</div>
                              </div>
                              <div
                                *ngIf="loop.cmP_ProductorServiceIDQualifier!=null && loop.cmP_ProductorServiceIDQualifier!=''"
                                class="row">
                                <h6>Composite Medical Procedure</h6>
                                <div class="col-lg-3">Product or Service ID Qualifier</div>
                                <div class="col-lg-9">: {{loop.cmP_ProductorServiceIDQualifier}}</div>
                              </div>
                              <div *ngIf="loop.cmP_ProductServiceID!=null && loop.cmP_ProductServiceID!=''" class="row">
                                <div class="col-lg-3">Product Service ID</div>
                                <div class="col-lg-9">: {{loop.cmP_ProductServiceID}}</div>
                              </div>
                              <div *ngIf="loop.cmP_ProcedureCode!=null && loop.cmP_ProcedureCode!=''" class="row">
                                <div class="col-lg-3">Procedure Code</div>
                                <div class="col-lg-9">: {{loop.cmP_ProcedureCode}}</div>
                              </div>
                              <div *ngIf="loop.cmP_ProcedureModifiers!=null && loop.cmP_ProcedureModifiers!=''"
                                class="row">
                                <div class="col-lg-3">Procedure Modifiers</div>
                                <div class="col-lg-9">: {{loop.cmP_ProcedureModifiers}}</div>
                              </div>
                              <div *ngIf="loop.cmP_Description!=null && loop.cmP_Description!=''" class="row">
                                <div class="col-lg-3">Description</div>
                                <div class="col-lg-9">: {{loop.cmP_Description}}</div>
                              </div>
                              <div *ngIf="loop.diagnosisCodePointers!=null && loop.diagnosisCodePointers!=''" class="row">
                                <div class="col-lg-3">Diagnosis Code Pointer</div>
                                <div class="col-lg-9">: {{loop.diagnosisCodePointers}}</div>
                              </div>
                              <div *ngIf="loop.messages!=null && loop.messages!=''" class="row">
                                <div class="col-lg-3">Messages</div>
                                <div class="col-lg-9">: {{loop.messages}}</div>
                              </div>
                            </div>
                            <div class="DTPDetails">
                              <ng-container *ngFor="let dtp of loop?.dtpDetails">
                                <div *ngIf="dtp.dateTimeQualifier!=null && dtp.dateTimeQualifier!=''" class="row">
                                  <div class="col-lg-3">{{dtp.dateTimeQualifier}}</div>
                                  <div class="col-lg-9">: {{dtp.dateTimePeriod|date:'MM/dd/yyyy'}}</div>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                    <br />
                    <hr />
                    <br />
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
            (click)="viewFiles271=false">Cancel</button>
        </div>
      </div>
    </div>
  </div>